<template>
  <model-form
    ref="modelForm"
    :model="tipPool"
    modal-type="modal"
    read-only
  >
    <div class="row q-col-gutter-x-sm items-center">
      <router-field
        :field-value="tipPool.tipPoolType?.name || 'No Tip Pool Type'"
        class="col-6"
        label="Tip Pool Type"
        :link="{
          name: 'admin:settings-category-name-id',
          params: {
            category: 'site',
            name: 'tip-pool-types',
            id: tipPool.tipPoolType?.id
          }
        }"
        :disable="$_.isNil(tipPool.tipPoolType)"
      />
      <model-form-input
        field="amount"
        class="col-6"
        label="Amount"
        :prefix="currentCircuit.localeCurrencySymbol"
        mask="#.##"
        fill-mask="0"
        readonly
      />
      <model-form-input
        field="state"
        class="col-6"
        label="State"
        :decode="state => $_.startCase(state)"
        readonly
      />
      <formatted-date
        :value="tipPool.distributedAt"
        class="col-6 q-mb-md"
        label="Distributed At"
        component="input"
      />
      <model-form-input
        field="tipPoolType.distributionStrategy"
        class="col-6"
        label="Distribution Strategy"
        :decode="strategy => $_.startCase(strategy)"
        readonly
      />
      <model-form-input
        field="tipPoolType.distributionSchedule"
        class="col-6"
        label="Distribution Schedule"
        :decode="schedule => $_.startCase(schedule)"
        readonly
      />
      <formatted-date
        :value="tipPool.openedAt"
        class="col-6 q-mb-md"
        label="Opened At"
        component="input"
      />
      <formatted-date
        :value="tipPool.closedAt"
        class="col-6 q-mb-md"
        label="Closed At"
        component="input"
      />
    </div>
  </model-form>
</template>

<script>
import FormattedDate from 'src/modules/admin/components/FormattedDate'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import RouterField from 'src/modules/admin/components/RouterField'

export default {
  name: 'TipPoolForm',
  components: {
    ModelForm,
    FormattedDate,
    RouterField
  },
  configuration: ['currentCircuit'],
  models: {
    tipPool: {
      tipPoolType: 'default',
      tipPoolTips: {
        fields: ['id', 'amount', 'state']
      }
    }
  },
  data () {
    return {
      tab: 'details'
    }
  }
}
</script>
